import type { BudgetType } from '@/lib/constants';

// One neutral step per group, darkest first (the lightest at 20%, so it still reads on Dusk Slate), in BUDGET_TYPES order: the split bar's segments and the swatch beside
// each Metas row share them, so a segment and its row read as one thing. Ink at different strengths, never hue —
// the buckets carry no semantic meaning to colour (DESIGN.md, Goals Editor; the bucket-colour decision is open).
export const GOAL_SHADES: Record<BudgetType, string> = {
  'fixed-expenses': 'bg-foreground/85',
  comfort: 'bg-foreground/70',
  goals: 'bg-foreground/55',
  pleasure: 'bg-foreground/40',
  'financial-freedom': 'bg-foreground/30',
  knowledge: 'bg-foreground/20',
};
